( function () {
	( function ( $ ) {
        $('.viewhotels').on('click', function(e){
            e.preventDefault();
            var destid = $(this).data('id');
            var thisbtn = $(this);
            $.ajax({
                url : obflexAjax.ajaxUrl,
                dataType : 'html', 
                data: {id:destid, action: 'viewhotels'},
                type:'GET',
                beforeSend: function( xhr ){  
                    thisbtn.text('Yükleniyor');
                },
                success:function(response){
                    thisbtn.text(thisbtn.data('btntext'));
                    $.magnificPopup.open({
                        items: {
                          src: response
                        },
                        preloader:false,
                        type: 'inline'
                    });                    
                }
            });
        });

        var carLmt = 90;
        $(".addReadMore").each(function() {
            if ($(this).find(".firstSec").length)
            return;
            var allstr = $(this).text();
            if (allstr.length > carLmt) {
                var firstSet = allstr.substring(0, carLmt);
                var secdHalf = allstr.substring(carLmt, allstr.length);
                var strtoadd = firstSet+"..." + "<span class='SecSec'>" + secdHalf + "</span><span class='readMore'  title='Click to Show More'></span><span class='readLess' title='Click to Show Less'></span>";
                $(this).html(strtoadd);
            }

        });
        $(document).on("click", ".readMore,.readLess", function() {
            $(this).closest(".addReadMore").toggleClass("showlesscontent showmorecontent");
        });
    })(jQuery);
})();